module.exports = __webpack_public_path__ + "img/integral.d6159da1.png";